import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    EyeFilled,
    EditFilled,
} from '@ant-design/icons';
import Parameters from 'shared/parameters';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import Text from 'antd/es/typography/Text';

interface Props {
    location: any;
    hideHeader?: boolean;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
export default function QuestionsPage(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();

    const [deletingItem, setDeletingItem] = useState(false);
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const columns = [
        {
            title: t('genDict.title'),
            key: 'title',
            dataIndex: 'title',
            render: (a: any) => <div dangerouslySetInnerHTML={{ __html: a }}/>,
        },
        {
            title: t('genDict.type'),
            key: 'type',
            dataIndex: 'type',
            render: (a: string) => {
                if (a === 'radio')
                    return <Text>{t('question.singleSelect')}</Text>;
                if (a === 'checkbox')
                    return <Text>{t('question.multiSelect')}</Text>;
                return <Text>{t('question.numeric')}</Text>;
            },
        },
        {
            title: t('genDict.status'),
            key: 'status',
            dataIndex: 'status',
        },
        {
            title: t('genDict.action'),
            key: 'action',
            render: (a: any) => {
                return <Space>
                    <Button type="default" shape="circle" icon={<EditFilled/>}
                            onClick={() => {
                                history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${RouteParams['courseId']}/curriculums/${RouteParams['curriculumId']}/contents/${RouteParams['id']}/questions/${a.id}/edit`);
                            }}/>
                    <Button type="primary" danger={true} shape="circle" icon={<DeleteOutlined/>}
                            onClick={() => confirm({
                                icon: <ExclamationCircleOutlined/>,
                                title: t('genDict.confirmDelete'),
                                okText: t('genDict.ok'),
                                cancelText: t('genDict.cancel'),
                                content: `${t('genDict.confirmDelete')} "${a.title}"`,
                                okButtonProps: { loading: deletingItem, danger: true },
                                onOk: async () => {
                                    setDeletingItem(true);
                                    API_SERVICE.removeQuestion(RouteParams['courseId'], RouteParams['curriculumId'], RouteParams['id'], a.id).then((d) => {
                                        notification.success({
                                            message: t('genDict.success'),
                                        });
                                        refreshItems();
                                    }).catch((e: any) => {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }).finally(() => {
                                        setDeletingItem(false);
                                    });
                                },
                            })
                            }/>
                </Space>;
            },
        },
    ];
    const refreshItems = async () => {
        try {
            setFetching(true);
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchQuestionsAdmin(RouteParams['courseId'], RouteParams['curriculumId'], RouteParams['id'], {
                order_by: 'id',
                page: 1,
                order: 'DESC',
            });
            setItems(items);
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
    }, []);
    return (
        <div className={props.hideHeader ? '' : 'list-page-wrapper'}>
            <Row gutter={20} justify={'space-between'}>
                <Col flex={'auto'}>
                    <Title level={3}>{t('genDict.questions')}</Title>
                </Col>
                <Col>
                    <Button type={'primary'}
                            onClick={() => history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${RouteParams['courseId']}/curriculums/${RouteParams['curriculumId']}/contents/${RouteParams['id']}/questions/create`)}>
                        {
                            t('genDict.add')
                        }
                    </Button>
                </Col>
            </Row>
            <Table loading={fetching} scroll={{ x: true }} pagination={{
                pageSize: 100,
                hideOnSinglePage: true,
            }} dataSource={items} columns={columns}/>
        </div>
    );
}
